import { ref, onMounted, onBeforeUnmount } from 'vue-demi';

export function useViewport({ horizontalTabRef }) {
    const viewportWidth = ref(window.innerWidth);
    const viewportHeight = ref(window.innerHeight);
    const handleViewportReize = () => {
        if (window.innerWidth !== viewportWidth.value) {
            viewportWidth.value = window.innerWidth;
        }
        if (window.innerHeight !== viewportHeight.value) {
            viewportHeight.value = window.innerHeight;
        }
    };

    const watchViewport = () => {
        window.addEventListener('resize', handleViewportReize);
    };

    const unWatchViewport = () => {
        window.removeEventListener('resize', handleViewportReize);
    };

    onMounted(() => {
        watchViewport();
    });

    onBeforeUnmount(() => {
        unWatchViewport();
    });

    return {
        viewportWidth,
        viewportHeight
    };
}
